import { LogRecord } from "@fairfleet/geotab";
import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { paginatedFeed } from "@/utilities/query/paginatedFeed";

export function useLogRecords(
  deviceId: string | undefined,
  fromDate: Date,
  toDate: Date,
  interval?: number,
) {
  const { geotabClient, activeSessionId } = useGeotabClient();

  return useQuery<LogRecord[]>({
    queryKey: ["logRecords", activeSessionId, deviceId, fromDate, toDate],

    queryFn: ({ signal }) => {
      if (!deviceId) {
        return Promise.resolve([]);
      }

      return paginatedFeed(
        geotabClient,
        "LogRecord",
        { deviceSearch: { id: deviceId }, fromDate, toDate },
        undefined,
        signal,
      );
    },

    refetchInterval: interval ?? 12000,
  });
}
